module.exports = "/_next/static/images/text@3x-7192545b9a8598b0b5905089c8072704.png";